import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import {
	ReportModeratedSearchParams,
	ReportModeratedService,
} from '@app/models/report-moderated';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ErrorService } from '@app/services/error.service';

@Component({
	selector: 'app-atom-report-moderated-counter',
	templateUrl: './atom-report-moderated-counter.component.html',
	styleUrls: ['./atom-report-moderated-counter.component.less'],
})
export class AtomReportModeratedCounterComponent implements OnInit, OnDestroy {
	/** @type {Subject<void>} Observables unsubscriber */
	protected unsubscribe: Subject<void> = new Subject<void>();

	@Input() searchParams: ReportModeratedSearchParams;

	loading = true;
	count: number;

	constructor(
		private reportModeratedService: ReportModeratedService,
		private errorService: ErrorService
	) {}

	ngOnInit() {
		this.refresh();

		this.searchParams.pipe(takeUntil(this.unsubscribe)).subscribe(() => {
			this.refresh();
		});
	}

	ngOnDestroy() {
		this.unsubscribe.next();
	}

	async refresh() {
		this.loading = true;
		if (this.searchParams) {
			const params = this.searchParams.toObjectSanitizedForCount();

			this.count = await this.reportModeratedService
				.count(params)
				.catch((err) => {
					this.errorService.handle(err);
					return null;
				});
		}
		this.loading = false;
	}
}
